import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function PrivacyPolicy() {
  const content = `
    <p>클로젯(이하 "회사")은 개인정보보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>

    <h2>제1조 (개인정보의 처리 목적)</h2>
    <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>

    <p><strong>1. 회원 가입 및 관리</strong></p>
    <p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지 목적</p>

    <p><strong>2. 재화 또는 서비스 제공</strong></p>
    <p>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 요금결제·정산</p>

    <p><strong>3. 개인 맞춤형 서비스 제공</strong></p>
    <ul>
      <li>키워드 기반 콘텐츠 추천</li>
      <li>사용자 행동 분석을 통한 개인화된 패션 콘텐츠 제공</li>
      <li>선호도 분석 및 관심 콘텐츠 추천</li>
    </ul>

    <p><strong>4. 마케팅 및 광고에의 활용</strong></p>
    <p>신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계</p>

    <h2>제2조 (처리하는 개인정보의 항목)</h2>
    <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>

    <p><strong>1. 필수항목</strong></p>
    <ul>
      <li>회원가입 시: 이메일, 비밀번호, 닉네임, 이름, 전화번호</li>
      <li>주문/배송 시: 수령인명, 배송지 주소, 우편번호, 전화번호</li>
      <li>결제 시: 결제 정보(토스페이먼츠를 통해 처리)</li>
    </ul>

    <p><strong>2. 선택항목</strong></p>
    <ul>
      <li>선호 키워드(스타일 태그)</li>
      <li>프로필 사진</li>
    </ul>

    <p><strong>3. 서비스 이용 과정에서 자동으로 생성되어 수집되는 정보</strong></p>
    <ul>
      <li>서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보</li>
      <li>콘텐츠 좋아요/조회 기록</li>
      <li>검색 기록</li>
      <li>장바구니 및 위시리스트 정보</li>
      <li>상품 리뷰 및 평가 정보</li>
    </ul>

    <h2>제3조 (개인정보의 처리 및 보유기간)</h2>
    <p><strong>1.</strong> 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>

    <p><strong>2.</strong> 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
    <ul>
      <li>회원 가입 및 관리: 회원 탈퇴 시까지</li>
      <li>재화 또는 서비스 제공: 재화·서비스 공급완료 및 요금결제·정산 완료 시까지</li>
      <li>단, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
        <ul>
          <li>가. 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지</li>
          <li>나. 서비스 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지</li>
        </ul>
      </li>
    </ul>

    <p><strong>3.</strong> 관련 법령에 의한 정보보유 사유</p>
    <ul>
      <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
      <li>대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)</li>
      <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
      <li>표시·광고에 관한 기록: 6개월 (전자상거래법)</li>
    </ul>

    <h2>제4조 (개인정보의 제3자 제공)</h2>
    <p><strong>1.</strong> 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>

    <p><strong>2.</strong> 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>

    <p><strong>가. 상품 판매자(셀러)</strong></p>
    <ul>
      <li>제공받는 자: 각 상품의 판매자</li>
      <li>제공 목적: 상품 배송 및 고객 응대</li>
      <li>제공 항목: 주문자명, 수령인명, 배송지 주소, 전화번호, 주문상품 정보</li>
      <li>보유 및 이용기간: 거래 완료 후 5년</li>
    </ul>

    <p><strong>나. 배송업체</strong></p>
    <ul>
      <li>제공받는 자: 판매자가 지정한 배송업체</li>
      <li>제공 목적: 상품 배송</li>
      <li>제공 항목: 수령인명, 배송지 주소, 전화번호</li>
      <li>보유 및 이용기간: 배송 완료 후 3개월</li>
    </ul>

    <h2>제5조 (개인정보처리의 위탁)</h2>
    <p><strong>1.</strong> 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
    <ul>
      <li>위탁받는 자: Supabase Inc.</li>
      <li>위탁하는 업무의 내용: 데이터 저장 및 관리</li>
      <li>위탁기간: 회원탈퇴 시 또는 위탁계약 종료 시까지</li>
    </ul>
    <ul>
      <li>위탁받는 자: 토스페이먼츠㈜</li>
      <li>위탁하는 업무의 내용: 결제 처리 및 결제 정보 관리</li>
      <li>위탁기간: 결제 완료 후 5년</li>
    </ul>

    <p><strong>2.</strong> 회사는 위탁계약 체결 시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>

    <h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
    <p><strong>1.</strong> 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
    <ul>
      <li>가. 개인정보 열람 요구</li>
      <li>나. 오류 등이 있을 경우 정정 요구</li>
      <li>다. 삭제 요구</li>
      <li>라. 처리정지 요구</li>
    </ul>

    <p><strong>2.</strong> 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.</p>

    <h2>제7조 (개인정보의 파기)</h2>
    <p><strong>1.</strong> 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>

    <p><strong>2.</strong> 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
    <ul>
      <li>파기절차: 불필요한 개인정보는 개인정보 보호책임자의 승인을 받아 파기합니다.</li>
      <li>파기방법: 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li>
    </ul>

    <h2>제8조 (개인정보의 안전성 확보조치)</h2>
    <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
    <ol>
      <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
      <li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
      <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
    </ol>

    <h2>제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
    <p><strong>1.</strong> 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</p>

    <p><strong>2.</strong> 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</p>

    <p><strong>3.</strong> 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>

    <h2>제10조 (개인정보 보호책임자)</h2>
    <p><strong>1.</strong> 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>

    <p><strong>▶ 개인정보 보호책임자</strong></p>
    <ul>
      <li>성명: 김재원</li>
      <li>직책: 대표</li>
      <li>연락처: support@clozet.my</li>
    </ul>

    <p><strong>2.</strong> 정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다.</p>

    <h2>제11조 (개인정보 처리방침 변경)</h2>
    <p>이 개인정보 처리방침은 2025년 11월 1일부터 적용됩니다. 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</p>

    <h2>제12조 (권익침해 구제방법)</h2>
    <p>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.</p>

    <ul>
      <li>▶ 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)</li>
      <li>▶ 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)</li>
      <li>▶ 대검찰청: (국번없이) 1301 (www.spo.go.kr)</li>
      <li>▶ 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)</li>
    </ul>

    <p><strong>부칙</strong><br>
    본 방침은 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    이메일: support@clozet.my</p>
  `;

  return (
    <TermsTemplate
      title="개인정보 처리방침"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
